import {
  Button,
  LinearProgress,
  Stack,
} from '@mui/material';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import React, { useState } from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { GetPatientById } from '../../Adapters/GetPatientById';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';

const PatientBox = ({
  patient,
  setShowForm,
  setSelectedPatient,
}) => {
  const [loading, setLoading] = useState();

  const ncode_label = FindLangKey(
    'general-public-label-national-code'
  );
  const patientId_label = FindLangKey(
    'new-referral-label-id'
  );
  const nameFamily_label = FindLangKey(
    'complete-user-information-input-name-family'
  );

  const birthDate_label = FindLangKey(
    'save-patients-for-visit-form-input-birth-date'
  );

  const edit_patient_label = FindLangKey(
    'save-patients-for-visit-edit-patient-info-btn'
  );

  return (
    <React.Fragment>
      <FrameCard
        cardProps={{
          p: '.4em',
          borderRadius: '20px',
        }}
        jsx={
          <Stack
            sx={{
              backgroundColor: 'white',
              borderRadius: '20px',
              gap: '.5em',
              p: '.4em',
            }}
          >
            <Stack direction="row-reverse" gap=".5em">
              <p>{ncode_label} :</p>
              <p>{patient?.FldNationalCode}</p>
            </Stack>
            <Stack direction="row-reverse" gap=".5em">
              <p>{patientId_label} :</p>
              <p>{patient?.IdPatient}</p>
            </Stack>
            <Stack direction="row-reverse" gap=".5em">
              <p>{nameFamily_label} :</p>
              <p>{ArabicToPersian(patient?.NamePatient)}</p>
              <p>
                {ArabicToPersian(patient?.FamilyPatient)}
              </p>
            </Stack>
            <Stack direction="row-reverse" gap=".5em">
              <p>{birthDate_label} :</p>
              <p>{patient?.FldBirthDate}</p>
            </Stack>
            <Stack direction="row-reverse" gap=".5em">
              <Button
                fullWidth
                variant="contained"
                color="colorPrimer"
                sx={{
                  color: `${themeColors.ColorPrimary} !important`,
                }}
                onClick={() => {
                  GetPatientById(
                    patient.IdPatient,
                    setSelectedPatient,
                    setShowForm,
                    setLoading
                  );
                }}
              >
                {edit_patient_label}
              </Button>
            </Stack>
            {loading === 'loading' ? (
              <LinearProgress />
            ) : (
              <></>
            )}
          </Stack>
        }
      />
    </React.Fragment>
  );
};

export default PatientBox;
